import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { Redlining } from '../../core/models/classes/redlining';
import { RegionReference } from '../../core/models/classes/region-reference';
import { Registration } from '../../core/models/classes/registration';
import { User } from '../../core/models/classes/user';
import { UserProfileModel } from '../../core/models/classes/user-profile';
import { RedliningService } from '../../core/services/redlining.service';
import { DeviceService } from '../../core/services/device.service';
import { RegionService } from '../../core/services/region.service';
import { UserService } from '../../core/services/user.service';
import { UserprofileComponent } from './userprofile/userprofile.component';
import EnjoyHint from 'xbs-enjoyhint/src/enjoyhint';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../core/services/settings.service';
import { QRModel } from '../../core/models/classes/qr';
import { Role } from '../../core/models/enums/user-role';
import { PermissionComponent } from '../permission/permission.component';
import { Region } from '../../core/models/classes/region';

@Component({
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})

export class UserComponent implements OnInit, AfterViewInit {
  user: Observable<User>;
  selectedUser: User;
  selectedUserProfile: UserProfileModel;
  pageTitle = $localize`User Details`;
  filtersLoaded: Promise<boolean>;
  public qrRegistrationCode: string = null;
  errorMessage: string;
  registration: Registration;
  regionReference: RegionReference;
  regRef: Observable<RegionReference[]>;
  regions: any;
  isUserLocked: boolean;
  hasAccess: boolean;
  isLockEnabled: boolean = true;
  isEditEnabled: boolean = true;
  isPasswordResetEnabled: boolean = true;
  showDelete: boolean = false;
  regDataSource;
  redDataSource;
  hostname: string = "-";
  redlinings: Redlining[] = [];
  redls: Observable<Redlining[]>;
  displayedUserColumns: string[] = ['id', 'name'];
  displayedRedColumns: string[] = [
    'id',
    'objectType',
    'name',
    'content',
    'priority',
    'prioritytext',
  ];
  hasLoaded: boolean;
  server: string;
  qrInfoDisplay: boolean;
  qrrawValue: QRModel = new QRModel();
  assignedRegions : Region[]=[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private regionService: RegionService,
    private redliningService: RedliningService,
    private deviceService: DeviceService,
    private settingService: SettingsService,
    public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef,
    private _snackBar: MatSnackBar
  ) {
    this.registration = new Registration();
    this.regions = [];
    this.regDataSource = new MatTableDataSource([]);
    this.redDataSource = new MatTableDataSource([]);
  }

  ngAfterViewInit(): void {
    this.redDataSource.paginator = this.paginator;
    this.redDataSource.sort = this.sort;
  }

  ngOnInit(): void {   
    this.fetchDomainName(); //get domainname from settings  
    const id = +this.route.snapshot.paramMap.get('id');
    this.userService.getUser(+id).subscribe({
      next: (data) => {
        this.selectedUser = data;
        this.setPermissions();       
        if (this.selectedUser !== null) {
          this.hasLoaded = true;          
          this.fetchLastLoginInfo(); //get last logged in device        
          this.fetchUserRole();       
          this.addUserRegistrationDataToQR();
        }
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  setPermissions(){
    //Super Admin : 1, Admin: 2, Normal User: 3, cSUser : 0

    //compare selected user with loggedin user
    var userId = localStorage.getItem('roleId');
    var currentId = this.selectedUser.roleId.toString();
    var loggedInUser = localStorage.getItem('loginId');
    var currentUser = this.selectedUser.id.toString();

    //1. Logged in as Admin, selected user is Super Admin, cannot edit and reset password of Super Admin
    if (userId === '2' && currentId === '1') {
      this.isEditEnabled = false;
      this.isPasswordResetEnabled = false;
    }

    //2. Loggedin user cannot lock/unlock himself & Super Admin cannot be locked/unlocked
    if (loggedInUser === currentUser || currentId === '1') {
      this.isLockEnabled = false;
    }

    this.selectedUser.role = Role[this.selectedUser.roleId];
    this.selectedUser.domain = this.selectedUser.cSID === 0 ? 'External' : 'cableScout';

    //1. Only External user can be deleted and never a cableScout User
    //2. Admin cannot delete SuperAdmin

    //3. Super Admin/Admin(Loggedin user) cannot delete himself
    if (loggedInUser === currentUser) {
      this.showDelete = false;
    }

    //4. Admin can delete another Admin and Normal User
    if(userId === '2' && this.selectedUser.domain === 'External' && (currentId === '2' || currentId === '3') && loggedInUser !== currentUser){
      this.showDelete = true;
    }

    //5. Super Admin can delete another Super Admin, Admin and Normal User
    if(userId === '1' && this.selectedUser.domain === 'External' && loggedInUser !== currentUser){
      this.showDelete = true;
    }
  }

  fetchLastLoginInfo(){
    this.deviceService.lastLoggedInDevice(this.selectedUser).subscribe({
      next: (data) => {
        if(data.status===200){
          this.selectedUser.lastDevice = data.body.name;
        }
        else{
          this.selectedUser.lastDevice = '-';
        }

      }
    });
  }

  fetchUserRole(){
    const userId = localStorage.getItem('loginId');
    this.userService.getUserRole(+userId).subscribe({
      next: (data) => {
        if (data !== 3) {
          this.hasAccess = true;
        }
      },
    });
  }

  fetchDomainName(){
    this.settingService.getSettings().subscribe({
      next: (s) => {
        if(s.domainName !== null){
          this.hostname = s.domainName;
        }
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  addUserRegistrationDataToQR(): void {
    this.userService.getIPandPort().subscribe({
      next: (data) => {
        this.server = data;
        this.registration.csUser = this.selectedUser.name;
        this.registration.csPassword = this.selectedUser.password; // update webapi
        this.registration.Server = this.server.split(':')[0];
        this.registration.port = +this.server.split(':')[1];
        this.registration.csUserId = this.selectedUser.id; //cSID
        this.registration.sUser = '';
        this.registration.sPassword = '';
        this.registration.schemaName = this.selectedUser.schemaName;
        this.isUserLocked = this.selectedUser.lock == 1 ? true : false;
        this.loaduserProfile();
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  loaduserProfile(): void {
    this.userService.getUserProfile(this.selectedUser.id).subscribe({
      next: (data) => {
        this.selectedUserProfile = data;
        this.fetchMailContent();      
        this.loadUserRedlinings();
        this.isUserLocked = this.selectedUser.lock == 1 ? true : false;
        this.loaduserRegions();
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  fetchMailContent(){
    this.userService.getMailContent(this.selectedUser.id).subscribe({
      next: (data) => {
        this.qrRegistrationCode = data;
        this.userService.getrawMailContent(this.selectedUser.id).subscribe({
          next: (data) => {
            if(data !== null){
              this.qrrawValue = JSON.parse(data) as QRModel;
              this.validateQrInformation();
            }
          },
        });
      },
    });
  }

  validateQrInformation(): void {
    if(this.qrrawValue.cSUser !== null && this.qrrawValue.cSUserId !== 0 &&
      this.qrrawValue.MapCacheId !== null && this.qrrawValue.MapCacheName !== null) {
      this.qrInfoDisplay = true;
    }
  }

  loadUserRedlinings(): void {
    this.redliningService.getUserRedlinings(this.selectedUser.id).subscribe({
      next: (red) => {
        this.selectedUser.redlinings = red.length;
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  userStatusChange(): void {
    this.isUserLocked = !this.isUserLocked;
    this.selectedUser.lock = this.isUserLocked == true ? 1 : 0;
    this.userService.lockUser(this.selectedUser).subscribe({
      next: (data) => {
        if (data.status != 200) {
          throw Error(data.statusText);
        }

        if (data.status === 200) {
          if (this.isUserLocked == true) {
            this._snackBar.open($localize`User locked`, '', {
              duration: 3000
            });
          } else {
            this._snackBar.open($localize`User unlocked`, '', {
              duration: 3000
            });
          }
        }
      },
    });
  }

  userRegions(id: number): void {
    this.regRef = this.userService.userRef;
    this.userService.getUserRegions(+id);
    this.regRef.subscribe({
      next: (reg) => {
        this.regions = reg;
        this.regDataSource.data = this.regions;
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  setUserPermissions() {
    //this.IsPermission=true;
    this.dialog.open(PermissionComponent, {
      panelClass: 'custom-dialog-container',
      data: '',
    });
  }

  qrCopy() {
    this._snackBar.open($localize`Activation code copied`, '', {
      duration: 3000
    });
  }

  addUserProfile(): void {
    this.dialog.open(UserprofileComponent, {
      data: this.selectedUser.id,
      panelClass: 'custom-dialog-container',
    });
    this.dialog._getAfterAllClosed().subscribe((res) => {
      this.loaduserProfile();

      //user role
      this.userService.getUser(this.selectedUser.id).subscribe({
        next: (data) => {
          this.selectedUser.role = Role[data.roleId];
        },
      }); 
    });
  }

  editUserProfile(): void {
    this.dialog.open(UserprofileComponent, {
      data: this.selectedUserProfile,
      panelClass: 'custom-dialog-container',
    });
    if (this.selectedUserProfile !== null) {
      // this.userService.editUserProfile(this.selectedUserProfile.ID,this.selectedUserProfile);
    }
    
    this.dialog.afterAllClosed.subscribe((p) => {
      //update user profile info
      this.userService.getUserProfile(this.selectedUser.id).subscribe({
        next: (data) => {        
          this.selectedUserProfile = data;        
        }});
     
      //update user role
      this.userService.getUser(this.selectedUser.id).subscribe({
        next: (data) => {
          this.selectedUser.role = Role[data.roleId];
        },
      });    
    });
  }

  updatePassword(): void {
    // this.dialog.open(ResetpasswordComponent, {
    //   data: this.selectedUserProfile,
    //   panelClass: 'custom-dialog-container',
    // });
    this.userService.resetPassword(this.selectedUserProfile).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this._snackBar.openFromComponent(EmailComponent, {
            duration: 3000,
          });
        }
      },
      error: (err) => {
        {
          throw Error(err.Status);
        }
      },
    });
  }

  sendNotification(): void {
    if (this.selectedUser !== null) {
      this.userService
        .sendCredentialNotification(this.selectedUser.id)
        .subscribe({
          next: (data) => {
            if (data === 1) {
              this._snackBar.openFromComponent(EmailComponent, {
                duration: 3000,
              });
            }
          },
          error: (err) => {
            this._snackBar.open(
              $localize`An error occurred while sending notification`,'', {
                duration: 3000
              });
          },
        });
    }
  }

  deleteUser(id: number) {
    this.dialog.open(deleteUser, { data: this.selectedUser });
    this.changeDetectorRefs.detectChanges();
  }

  loaduserRegions(): void {
    this.regionService.getAssignedRegions(this.selectedUser.id).subscribe({
      next: (data) => {
        this.assignedRegions=data;
      },
    });
  }
}

@Component({
  selector: 'deleteUser',
  templateUrl: 'deleteUser.html',
})

export class deleteUser {
  selectedData: User;
  constructor(
    public dialogRef: MatDialogRef<deleteUser>,
    @Inject(MAT_DIALOG_DATA) public data: User,
    private router: Router,
    private _snackBar: MatSnackBar,
    private userService: UserService
  )
  {
    this.selectedData = data;
  }

  ConfirmDelete(): void {
    if (this.selectedData !== null || this.selectedData !== undefined) {
      this.userService.deletRecord(this.selectedData.id).subscribe({
        next: (data) => {
          if (data.status === 200) {
            this._snackBar.open($localize `Selected user has been deleted`, '', {
              duration: 3000
            });
            this.dialogRef.close();
          }
        },
      });
      this.router.navigateByUrl(`/default`);
    }
  }
}

@Component({
  selector: 'example',
  templateUrl: 'emailcomponent.html',
})
export class EmailComponent {}
